import { N32_02 } from "./N32_02"

export const N32 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 13,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Sales Performance by PMR",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'PMR Code',
                        "columnName": 'AgentCode',
                        "width": '150px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Employee Code',
                        "columnName": 'EmployeeCode',
                        "width": '160px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'PMR Name',
                        "columnName": 'AgentName',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Region',
                        "columnName": 'RegionCode',
                        "width": '100px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'District Name',
                        "columnName": 'DistrictName',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Area Name',
                        "columnName": 'TerritoryName',
                        "width": '400px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'LY Sales',
                        "columnName": 'LYSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'Target',
                        "columnName": 'TargetSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Performance %',
                        "columnName": 'Performance',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": "AgentName",
                "endpoint": "N32",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": N32_02
                }
            }
        }
    }
}